export default "__VITE_ASSET__yHwyh3CK__"